import styled from 'styled-components'
import { Colors } from '../../constants'

export const OutputDisclaimer = styled.small`
  margin-top: 5px;
  margin-bottom: 20px;
  display: block;
  font-size: 10px;
  color: ${Colors.DarkerGray};
`
